<div class="dropdown" dropdown #dropdown="bs-dropdown" (onShown)="onOpen()" (onHidden)="onHide()" [insideClick]="true">

    <button id="nav-quicklink-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle"
        aria-controls="nav-quicklink-dropdown-list">
        <i class="fa-light fa-screwdriver-wrench fa-lg"></i>
    </button>

    <div class="dropdown-menu dropdown-menu-right px-3 shadow-sm" *dropdownMenu [style.minWidth.px]="200 + (assignmentPrefix?.length * 10)" >
        <form novalidate [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row gutter-xxs" *ngIf="open">
                <div class="col-auto align-self-center">
                    {{assignmentPrefix}}
                </div>
                <div class="col">
                    <kupari-input formControlName="id" [placeholder]="'assignment.enter_worknumber'" [autofocus]="true"
                        [validation]="[{
                        rule:form.get('id').errors?.required && form.get('id').touched,
                        message: 'common.errors.required_field'
                    },{
                        rule:form.get('id').errors?.pattern && form.get('id').dirty,
                        message: 'common.errors.integer_invalid'
                    }]">
                    </kupari-input>
                </div>

                <div class="col-auto">
                    <kupari-button [type]="'submit'" [class]="'btn btn-sm btn-primary'" [text]="'common.actions.open'">
                    </kupari-button>
                </div>
            </div>
        </form>
    </div>

</div>
